/** Keep in sync with package.json pdfjs-dist version. */
const PDFJS_VERSION = "4.10.38";

/** CRA-friendly PDF.js entry (explicit path avoids "Cannot find module 'pdfjs-dist'"). */
export async function loadPdfJs() {
  return import("pdfjs-dist/build/pdf.mjs");
}

/** Worker URLs in priority order (CDN first — nginx often serves .mjs as application/octet-stream). */
export function getPdfWorkerCandidates(pdfjsVersion = PDFJS_VERSION) {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const origin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
  const local = (ext) => (origin ? `${origin}${base}/pdf.worker.min.${ext}` : null);

  return [
    `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.mjs`,
    local("js"),
    local("mjs"),
    `https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.mjs`,
  ].filter(Boolean);
}

export async function loadPdfDocumentFromBytes(pdfjs, data) {
  const bytes = data.slice(0);
  const version = pdfjs.version || PDFJS_VERSION;
  let lastError;

  for (const workerSrc of getPdfWorkerCandidates(version)) {
    try {
      pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
      return await pdfjs.getDocument({ data: bytes, withCredentials: false }).promise;
    } catch (err) {
      lastError = err;
    }
  }

  throw lastError instanceof Error ? lastError : new Error("PDF worker failed to load");
}
